import PrivacyPolicy from "./PrivacyPolicy";

export default class TermsOfService extends PrivacyPolicy {
  static defaultProps = {
    keyword: 'Terms of Service',
    fieldPrefix: 'termsOfService',
  }
}
